module.exports = __webpack_public_path__ + "sunsemweb/img/jr.a8006229.png";